module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-2": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "textos-marco",
    attrs: {
      "pa-3": "",
      "aligner": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.texto))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27aa485b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Textomarco.vue
// module id = 954
// module chunks = 1